/* eslint-disable react/require-default-props */
import React, { useRef } from 'react';
import { Text } from '../../atoms/Text/Text';
import { Button } from '../../atoms/Button/Button';
let modalIdCounter = 0;
function generateModalId() {
    modalIdCounter += 1;
    return modalIdCounter;
}
export function ModalHeader({ title, subtitle, onClose, secondaryActions, showDivider = true, closeLabel = 'Close', titleId: titleIdProp, subtitleId: subtitleIdProp, className = '' }) {
    const idRef = useRef(generateModalId());
    const resolvedTitleId = titleIdProp || `qmb-ui-modal-title-${idRef.current}`;
    const resolvedSubtitleId = subtitleIdProp || `qmb-ui-modal-subtitle-${idRef.current}`;
    const headerClasses = ['qmb-ui-modal-header', className].filter(Boolean).join(' ');
    return (React.createElement("header", { className: headerClasses },
        React.createElement("div", { className: "qmb-ui-modal-header__row qmb-ui-modal-header__row--title" },
            React.createElement("div", { className: "qmb-ui-modal-header__title", id: resolvedTitleId }, typeof title === 'string' ? (React.createElement(Text, { variant: "medium", as: "h2" }, title)) : (title)),
            (secondaryActions || onClose) && (React.createElement("div", { className: "qmb-ui-modal-header__actions" },
                secondaryActions,
                onClose && (React.createElement(Button, { className: "qmb-ui-modal-header__close", onClick: onClose, "aria-label": closeLabel },
                    React.createElement("i", { className: "fa-light fa-xmark", "aria-hidden": "true" })))))),
        subtitle && (React.createElement("div", { className: "qmb-ui-modal-header__row" },
            React.createElement("div", { className: "qmb-ui-modal-header__subtitle", id: resolvedSubtitleId }, typeof subtitle === 'string' ? React.createElement(Text, { variant: "body" }, subtitle) : subtitle))),
        showDivider && React.createElement("hr", { className: "qmb-ui-modal-header__divider", "aria-hidden": "true" })));
}
